import React, { Component } from "react";
import NavBar from "../components/navBar";
import { Link as Scroll } from "react-scroll";
import LevtyButton from "../components/levty-ui/levtyButton";
import Metatags from "../components/metatags";
import Rellax from 'react-rellax';
import { InlineIcon } from "@iconify/react";

import star from '@iconify/icons-ant-design/star-outlined';
import teachIcon from '@iconify/icons-mdi/teach';
import baselineAccessTime from '@iconify/icons-ic/baseline-access-time';
import accountGroup from '@iconify/icons-mdi/account-group';
import commentOutline from '@iconify/icons-mdi/comment-outline';
import giftOutline from '@iconify/icons-mdi/gift-outline';
import chartBellCurveCumulative from '@iconify/icons-mdi/chart-bell-curve-cumulative';
import Footer from "../components/footer";
import ScrollTop from "../components/scroll-top/scrollTop";
import { getCampaignReferrer, setCampaignReferrer, getUrlParameter } from "../utils/referrer";

class Carreiras extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    const utmCampaign = getCampaignReferrer();
    if (!utmCampaign) {
      const campaignName = getUrlParameter("utm_campaign");
      const campaignSource = getUrlParameter("utm_source");
      const campaignMedium = getUrlParameter("utm_medium");
      const campaignTerm = getUrlParameter("utm_term");
      const campaignContent = getUrlParameter("utm_content");
      if (campaignName && campaignSource) {
        const utmParams = {
          name: campaignName,
          source: campaignSource,
          medium: campaignMedium,
          term: campaignTerm,
          content: campaignContent
        }
        setCampaignReferrer(utmParams);
      }
    }
  }

  render() {


    const rightButton = {
      label: "Veja nossas vagas",
      onClick: () => this.props.history.push("/carreiras/vagas"),
      color: "light"
    }

    return (
      <>
        <Metatags
          title="Carreiras | LEVTY"
          description="Buscamos pessoas incríveis para fazer coisas incríveis"
          url={window.location.href}
          canonical="/carreiras"
        />
        <NavBar
          rightButton={rightButton}
        />
        <main>
          <section id="start" className="notranslate lev-carrers-hero animated fadeIn slow">

            <span   translate="no" className="notranslate lev-carrers-hero-bg"></span>
            <span   translate="no" className="notranslate lev-careers-hero-img"></span>
            <div   translate="no" className="notranslate container">
              <div   translate="no" className="notranslate row">
                <div   translate="no" className="notranslate col-12">
                  <h1   translate="no" className="notranslate lev-max-width-600 mb-3 display-1">Buscamos pessoas incríveis para fazer coisas incríveis</h1>
                  <p   translate="no" className="notranslate lev-max-width-600 lead mb-5">
                    Nós acreditamos que o sucesso está diretamente relacionado à capacidade de se reinventar e agir de forma
                    rápida às mudanças e atualizações constantes do mercado.
                  </p>
                  <Scroll
                    className="notranslate btn btn-lg btn-primary btn-white-text d-none d-lg-inline-block"
                    to="saiba-mais"
                    duration={1100}
                    smooth={true}
                  >
                    Saiba mais
                  </Scroll>
                </div>
                <div   translate="no" className="notranslate col-12 mt-5 d-none d-sm-flex d-lg-none">
                  <img src="/images/illustrations/welcome.svg" className="notranslate img-fluid" alt="" />
                </div>
              </div>
            </div>
            <img src="/images/illustrations/welcome.svg" className="notranslate img-fluid mt-5 d-sm-none" alt="" />

          </section>

          <section id="saiba-mais" className="notranslate lev-carrers-features">
            <div   translate="no" className="notranslate container">
              <div   translate="no" className="notranslate row">
                <div   translate="no" className="notranslate col-lg-7">
                  <h2   translate="no" className="notranslate lev-max-width-550 display-3">Fazer o que você gosta pode ter ainda mais vantagens</h2>
                  <p   translate="no" className="notranslate lead mb-0">
                    Nossa cultura gera um dia a dia informal, flexível, permitindo aos nossos colaboradores as melhores condições para focarem em seus resultados.
                  </p>
                </div>
              </div>
              <div   translate="no" className="notranslate lev-carrers-features-row row">
                <div   translate="no" className="notranslate col">
                  <div   translate="no" className="notranslate lev-carrers-features-card-with-shadow card">
                    <div   translate="no" className="notranslate media">
                      <div
                        className="notranslate lev-carrers-features-card-icon d-flex align-self-center justify-content-center align-items-center">
                        <InlineIcon color="white" width="30" icon={baselineAccessTime} />
                      </div>
                      <div   translate="no" className="notranslate media-body">
                        <h3   translate="no" className="notranslate h5">Horário flexível</h3>
                        <p   translate="no" className="notranslate mb-0">Você com autonomia para gerenciar seu horário.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div   translate="no" className="notranslate col">
                  <div   translate="no" className="notranslate card">
                    <div   translate="no" className="notranslate media">
                      <div
                        className="notranslate lev-carrers-features-card-icon d-flex align-self-center justify-content-center align-items-center">
                        <InlineIcon color="white" width="30" icon={teachIcon} />
                      </div>
                      <div   translate="no" className="notranslate media-body">
                        <h3   translate="no" className="notranslate h5">Capacitação</h3>
                        <p   translate="no" className="notranslate mb-0">Você recebe o treinamento que precisa para sua função.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div   translate="no" className="notranslate col">
                  <div   translate="no" className="notranslate lev-carrers-features-card-with-shadow card">
                    <div   translate="no" className="notranslate media">
                      <div
                        className="notranslate lev-carrers-features-card-icon d-flex align-self-center justify-content-center align-items-center">
                        <InlineIcon color="white" width="30" icon={accountGroup} />
                      </div>
                      <div   translate="no" className="notranslate media-body">
                        <h3   translate="no" className="notranslate h5">Colaboração</h3>
                        <p   translate="no" className="notranslate mb-0">Prezamos por um ambiente acolhedor e confortável.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div   translate="no" className="notranslate lev-carrers-features-mt-40 row">
                <div   translate="no" className="notranslate col">
                  <div   translate="no" className="notranslate card">
                    <div   translate="no" className="notranslate media">
                      <div
                        className="notranslate lev-carrers-features-card-icon d-flex align-self-center justify-content-center align-items-center">
                        <InlineIcon color="white" width="30" icon={giftOutline} />
                      </div>
                      <div   translate="no" className="notranslate media-body">
                        <h3   translate="no" className="notranslate h5">Benefícios</h3>
                        <p   translate="no" className="notranslate mb-0">Conte com um pacote pensado em seu bem-estar e outros incentivos.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div   translate="no" className="notranslate col">
                  <div   translate="no" className="notranslate lev-carrers-features-card-with-shadow card">
                    <div   translate="no" className="notranslate media">
                      <div
                        className="notranslate lev-carrers-features-card-icon d-flex align-self-center justify-content-center align-items-center">
                        <InlineIcon color="white" width="30" icon={commentOutline} />
                      </div>
                      <div   translate="no" className="notranslate media-body">
                        <h3   translate="no" className="notranslate h5">Informalidade</h3>
                        <p   translate="no" className="notranslate mb-0">Um clima único é resultado de pessoas extraordinárias.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div   translate="no" className="notranslate col">
                  <div   translate="no" className="notranslate card">
                    <div   translate="no" className="notranslate media">
                      <div
                        className="notranslate lev-carrers-features-card-icon d-flex align-self-center justify-content-center align-items-center">
                        <InlineIcon color="white" width="30" icon={chartBellCurveCumulative} />
                      </div>
                      <div   translate="no" className="notranslate media-body">
                        <h3   translate="no" className="notranslate h5">Oportunidades</h3>
                        <p   translate="no" className="notranslate mb-0">Oferecemos o necessário para você libertar seu potencial.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="notranslate lev-carrers-talent">
            <div   translate="no" className="notranslate container">
              <div   translate="no" className="notranslate row justify-content-center">
                <div   translate="no" className="notranslate col-lg-5 col-xl-4">
                  <h2   translate="no" className="notranslate display-4">
                    Temos lugar para todos os talentos
                  </h2>
                  <p   translate="no" className="notranslate lead mb-0 d-lg-none">
                    Nos preocupamos em criar um ambiente de trabalho informal, totalmente horizontal e colaborativo, com
                    pessoas acessíveis e dispostas a ensinar.
                  </p>
                  <ul className="notranslate list-group list-group-flush">
                    <li className="notranslate list-group-item">
                      <InlineIcon color="#0096D5" width="21" icon={star} className="notranslate InlineIcon" />
                      Suporte e infraestrutura
                    </li>
                    <li className="notranslate list-group-item">
                      <InlineIcon color="#0096D5" width="21" icon={star} className="notranslate InlineIcon" />
                      Desenvolvimento e pesquisa
                    </li>
                    <li className="notranslate list-group-item">
                      <InlineIcon color="#0096D5" width="21" icon={star} className="notranslate InlineIcon" />
                      Projetos e serviços especializados
                    </li>
                    <li className="notranslate list-group-item">
                      <InlineIcon color="#0096D5" width="21" icon={star} className="notranslate InlineIcon" />
                      Marketing e comunicação
                    </li>
                  </ul>
                </div>

                <div   translate="no" className="notranslate col-lg-5 col-xl-4 offset-lg-1">

                  <p   translate="no" className="notranslate lead mb-0 d-none d-lg-block">
                    Nos preocupamos em criar um ambiente de trabalho informal, totalmente horizontal e colaborativo, com
                    pessoas acessíveis e dispostas a ensinar.
                  </p>
                  <img src="/images/illustrations/seated-woman.svg" className="notranslate lev-carrers-talent-img" alt="" />
                </div>
              </div>
            </div>
          </section>
          <section className="notranslate lev-carrers-gptw">
            <div   translate="no" className="notranslate container">
              <div   translate="no" className="notranslate row justify-content-center">
                <div   translate="no" className="notranslate col-lg-5 col-xl-4">
                  <h2   translate="no" className="notranslate display-3">
                    LEVTY é GPTW
                  </h2>
                  <p   translate="no" className="notranslate lead">
                    A <b>Great Place to Work</b> é uma consultoria global que, através de alta confiança, inovação e produtividade, auxilia organizações a antingirem melhores resultados. 
                  </p>
                  <p   translate="no" className="notranslate lead">
                    Agora, a <b>LEVTY</b> possui certificação <b>GPTW</b> e isso significa que somos uma das melhores empresas para se trabalhar no Brasil.
                  </p>
                  <p   translate="no" className="notranslate lead">
                    Os benefícios da certificação envolveram um entendimento melhor da opinião dos colaboradores, dados concretos para a tomada de decisão e fortalece os melhores talentos dentro da empresa
                  </p>
                </div>
                <div   translate="no" className="notranslate col-lg-5 col-xl-4 offset-lg-1">
                  <figure className="notranslate lev-carrers-gptw-figure">
                    <img src="/assets/levty/selo-gptw.webp" className="notranslate img-fluid" alt="Selo GPTW" />
                  </figure>
                </div>
              </div>
            </div>
          </section>
          <section className="notranslate lev-carrers-cta">
            <Rellax className="notranslate lev-geometric-shape lev-geometric-plus-2 rellax" />

            <div   translate="no" className="notranslate container">
              <div   translate="no" className="notranslate row justify-content-center">
                <div   translate="no" className="notranslate col-lg-7 text-center">
                  <h2   translate="no" className="notranslate display-3">
                    Junte-se a nós
                  </h2>
                  <p   translate="no" className="notranslate lead mb-5">
                    Estamos sempre procurando pessoas criativas e talentosas para ingressar na nossa equipe. Confira nossas
                    vagas abertas e cadastre seu currículo.
                  </p>
                  <LevtyButton label="Veja as nossas vagas" onClick={() => this.props.history.push("/carreiras/vagas")} />
                </div>
              </div>
            </div>
          </section>
        </main>
        <ScrollTop />
        <Footer />
      </>
    );
  }

}

export default Carreiras;

